import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';

  import useContext from '@/composables/useContext';
  import useGiftCard from '@/composables/useGiftCard';
  import useWebsiteTexts from '@/composables/useWebsiteTexts';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Logout',
  setup(__props) {

  const { channel, navigate } = useContext();
  const { removeAllGiftCards } = useGiftCard();
  const { websiteText } = useWebsiteTexts();
  const rootPath = computed(() => {
    return channel.value?.rootPath || '';
  });

  async function logout() {
    try {
      await removeAllGiftCards();

      if (rootPath.value) {
        await navigate(rootPath.value);
      }
    } catch (ex) {
      console.warn(ex);
      alert(websiteText('global__failed_to_remove_giftcard').value);
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "logout",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (logout()))
  }, _toDisplayString(_unref(websiteText)('header_giftcardlogout').value), 1))
}
}

})